
/*
 * Public API Surface of ngx-translate-router
 */

export * from './lib/localize-router.module';
export * from './lib/localize-router.parser';
export * from './lib/localize-router.service';
export * from './lib/localize-router.pipe';
export * from './lib/localize-router.config';
export * from './lib/localize-router-config-loader';
export * from './lib/gilsdav-reuse-strategy';
export * from './lib/localized-router';
export * from './lib/localized-matcher-url-segment';
